import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header/header";
import SideMenu from "./sideMenu/sideMenu.jsx";
import { useState } from "react";
import Footer from "./footer/footer";

const LayoutComponent = ({ refresh }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleReload = (reload) => {
    setIsLoading(reload);
  };

  return (
    <>
      {isLoading ? (
        <div></div>
      ) : (
        <div className="main-dialog-box">
          <div className="main-dialog-first">
            <Header refreshHeader={refresh} reload={handleReload}></Header>
          </div>
          <div className="main-dialog-second">
            <div className="main-dialog-layout">
              <SideMenu></SideMenu>
              <div className="center-layout">
                <div className="layout-screen">
                  <Outlet></Outlet>
                </div>
                <Footer></Footer>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LayoutComponent;
